<template>
  <v-app-bar clipped-right app>
    <!-- Boton de minimizar el menu -->
    <v-app-bar-nav-icon @click.stop="set_drawer(!drawer)"/>

    <!-- Nombre del centro -->
    <v-toolbar-title style="width:30%" class="ml-0 pl-4 hidden-sm-and-down">
      <span>{{ $store.state.centro.centro.nombre }}</span>
    </v-toolbar-title>

    <v-spacer />

    <!-- Buscador de clientes -->
    <v-autocomplete
        v-if="!centro.is_central"
        id="appbar_autocomplete_cliente"
        flat
        rounded
        solo
        hide-details
        ref="autocomplete"
        prepend-inner-icon="mdi-account-search"
        :label='$t("Buscar cliente")'
        class="hidden-sm-and-down"
        v-model="cliente_autocomplete"
        :items="cliente_autocomplete_entries"
        :search-input.sync="search"
        @change="cliente_autocomplete_change"
        hide-no-data
        no-filter
    >
      <template v-slot:item="data">
        <template>
          <v-list-item-avatar>
            <v-img :src="data.item.foto_url_absolute_path" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title
                v-html="data.item.text + (data.item.manual_code? ' - ' + data.item.manual_code : data.item.code? ' - ' + data.item.code : '')"
            />
            <v-list-item-subtitle>
              <span v-if="show_email_cliente">{{ data.item.email }}</span>
              <span v-if="data.item.email && data.item.movil && show_email_cliente && show_movil_cliente"> - </span>
              <span v-if="show_movil_cliente" >{{ data.item.prefijo_tel ? `+${data.item.prefijo_tel}` : '' }}{{ data.item.movil }}</span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>

    </v-autocomplete>

<!--    buscar clientes en dispositivos moviles-->
    <v-btn class="hidden-md-and-up" icon @click="show_buscar_cliente=true">
      <v-icon>mdi-magnify</v-icon>
    </v-btn>

    <DialogBuscadorAppBarMovil
        v-if="show_buscar_cliente"
        v-model="show_buscar_cliente"
        :show_email_cliente="show_email_cliente"
        :show_movil_cliente="show_movil_cliente"
        :show_buscar_cliente="show_buscar_cliente"
    />
    <!-- Icono de chat -->
<!--    <v-btn v-if="!centro.is_central" style="color: rgba(0, 0, 0, 0.54)" text :title="$t('Chat')" class="mx-3" @click="$emit('on_click_open_chat')">-->
<!--      <v-icon left color="gray">mdi-chat-outline</v-icon>-->
<!--      <span class="text-capitalize">{{ $t('Chat') }}</span>-->
<!--    </v-btn>-->

    <!-- Icono de notificaciones -->
    <v-menu
        offset-y
        bottom
        v-if="!centro.is_central"
    >
      <template v-slot:activator="{ on }">
        <v-btn icon :title="$t('Notificaciones de Koibox')" class="mx-3" v-on="on">
          <v-icon v-if="!show_notificaciones_pasadas && notificaciones.length > 0 && !user.is_superuser" class="orange--text parpadea">mdi-bell-alert</v-icon>
          <v-icon v-else>mdi-bell</v-icon>
        </v-btn>
      </template>
      <v-list
          dense
          subheader
          class="notificacion"
          width="350px"
      >
        <v-toolbar
            elevation="1"
            dense
            class="font-weight-bold"
            @click.stop
            width="350px"
        >
          <v-row>
            <v-col cols="7" class="mt-5 pa-1" offset="2">
              {{ $t('Notificaciones de Koibox') }}
            </v-col>
            <v-col cols="2">
              <v-btn
                  icon
                  class="text--primary"
                  :title="$t('Ver Notificaciones nuevas')"
                  @click="get_notificaciones(false)"
                  v-if="show_notificaciones_pasadas"
              >
                <v-icon>mdi-eye-off</v-icon>
              </v-btn>
              <v-btn
                  icon
                  class="text--primary"
                  :title="$t('Ver Notificaciones leídas')"
                  @click="get_notificaciones(true)"
                  v-else
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
        <v-list-item
            v-for="(notificacion, index) in notificaciones"
            :key="index"
            @click="abrir_notificacion(notificacion.id)"
        >
          <v-list-item-content class="pb-3">
            <v-list-item-title>
              {{ notificacion.titulo | truncate(50) }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="notificacion.fecha">
              {{ notificacion.fecha | date }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="notificaciones.length === 0">
          <v-list-item-title>
            {{ show_notificaciones_pasadas? $t('No hay notificaciones leídas') : $t('No hay notificaciones nuevas') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- Cumples -->
    <v-btn
        v-if="centro.is_aviso_notificaciones_cumpleanios && clientes_cumpleanios > 0"
        style="color: darkorange"
        text
        class="mx-3"
        depressed
        @click="dialog_cumples_clientes = true"
    >
      <v-icon left color="gray">mdi-cake-variant</v-icon>
      <span class="text-capitalize hidden-sm-and-down">{{ $t('Cumpleaños') }}</span>
    </v-btn>

    <v-btn
        v-if="centro.is_show_whatsapp_bussiness && centro.id===1"
        icon class="mx-3"
        @click="$emit('on_click_open_chat')"
    >
      <v-badge
          v-if="centro.whatsapps_unreads > 0"
          value="!"
          content="!"
          color="primary"
          bordered
      >
        <v-icon :class="{'green--text': true, 'parpadea': centro.whatsapps_unreads > 0}">mdi-whatsapp</v-icon>
      </v-badge>
      <v-icon v-else :class="{'green--text': true, 'parpadea': centro.whatsapps_unreads > 0}">mdi-whatsapp</v-icon>
    </v-btn>

    <v-btn
        v-if="credito_sms_restante === 0"
        color="red"
        text
        depressed
        @click="on_click_sin_credito_sms"
    >
      <span class="text-capitalize hidden-sm-and-down">{{ $t('Sin crédito SMS') }}</span>
    </v-btn>

    <!-- Boton desplegable con las opciones de usuario -->
    <v-menu
        v-model="show_top_menu"
        bottom
        origin="center center"
        offset-y
    >
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on">
          <v-icon left v-bind:style="[socketConnected ? {color: 'green'} : {color: 'red'}]">mdi-account</v-icon>
          <span class="text-capitalize"  style="color: rgba(0, 0, 0, 0.54)">{{ $store.state.auth.user.first_name }}</span>
        </v-btn>
      </template>
      <v-list>
        <!-- Codigo de cliente -->
        <v-list-item class="primary lighten-4">
          <v-list-item-title>
            <span class="ml-2 body-2">{{ $t("Cód. cliente") }}: {{ $store.state.centro.centro.id }}</span>
          </v-list-item-title>
        </v-list-item>
        <!-- Plan centro -->
        <v-list-item v-if="!centro.is_central && centro.is_premium && $store.state.centro.centro.plan_contratado_obj">
          <v-list-item-title :style="`color: ${color_plan};`">
            <v-icon :color="color_plan">mdi-medal</v-icon>
            <span class="ml-2 body-2 font-weight-bold">{{ $store.state.centro.centro.plan_contratado_obj.descripcion }}</span>
          </v-list-item-title>
        </v-list-item>
        <v-divider/>
        <!-- Perfil -->
        <v-list-item @click="go_to_perfil">
          <v-list-item-title>
            <v-icon color="primary">mdi-account</v-icon>
            <span class="ml-2 body-2">{{ $t("Perfil") }}</span>
          </v-list-item-title>
        </v-list-item>
        <!-- Cambio de idioma -->
        <v-menu open-on-hover offset-x left>
          <template v-slot:activator="{ on }">
            <v-list-item @click.prevent v-on="on">
              <v-list-item-title>
                <v-icon color="primary">mdi-translate</v-icon>
                <span class="ml-2 body-2">{{ $t("Idioma") }}</span>
              </v-list-item-title>
              <v-list-item-action>
                <v-icon color="primary">mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
          <!-- Lista de idiomas -->
          <v-list>
            <v-list-item @click="change_language(1)">
              <v-list-item-title>
                <span class="ml-2 body-2">{{ $t("Español") }}</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="change_language(2)">
              <v-list-item-title>
                <span class="ml-2 body-2">{{ $t("Inglés") }}</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="change_language(7)">
              <v-list-item-title>
                <span class="ml-2 body-2">{{ $t("Portugués") }}</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="change_language(4)">
              <v-list-item-title>
                <span class="ml-2 body-2">{{ $t("Italiano") }}</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="change_language(5)">
              <v-list-item-title>
                <span class="ml-2 body-2">{{ $t("Francés") }}</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- Cambiar a un centro de la misma franquicia -->
        <v-list-item v-if="show_cambiar_usuario" @click="open_dialog_cambiar_usuario">
          <v-list-item-title>
            <v-icon color="primary">mdi-swap-horizontal</v-icon>
            <span class="ml-2 body-2">{{ $t("Cambiar centro") }}</span>
          </v-list-item-title>
        </v-list-item>
        <!-- Apartado de tickets -->
        <v-list-item
            v-if="centro.distribuidor !== CONSTANTS.DISTRIBUIDORES.SEBYMAR"
            @click="$router.push({name: 'tickets'})">
          <v-list-item-title>
            <v-icon color="primary">mdi-ticket</v-icon>
            <span class="ml-2 body-2">{{ $t("Soporte") }}</span>
          </v-list-item-title>
        </v-list-item>
          <v-list-item
              v-if="centro.distribuidor !== CONSTANTS.DISTRIBUIDORES.SEBYMAR"
              @click="enable_openreplay">
              <v-list-item-title>
                  <v-icon color="primary">mdi-remote-desktop</v-icon>
                  <span class="ml-2 body-2">{{ $t("Asist. remota") }}</span>
              </v-list-item-title>
          </v-list-item>
        <!-- Cerrar sesion -->
        <v-divider></v-divider>
        <v-list-item @click="logout">
          <v-list-item-title>
            <v-icon color="primary">mdi-location-exit</v-icon>
            <span class="ml-2 body-2">{{ $t("Cerrar sesión") }}</span>
          </v-list-item-title>
        </v-list-item>
        <v-divider v-if="$store.state.auth.user.is_superuser"/>
        <v-list-item v-if="$store.state.auth.user.is_superuser" @click="open_admin">
          <v-list-item-title>
            <v-icon color="red">mdi-shield-home</v-icon>
            <span class="ml-2 body-2">{{ $t("Administración") }}</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- Fin menu desplegable -->

    <!-- Dialog con los detalles de la notificación -->
    <DialogNotificationDetalle
      v-if="dialog_detalle_notificacion"
      v-model="dialog_detalle_notificacion"
      :notificacion_id="notificacion_seleccionada"
      :show_pasadas="show_notificaciones_pasadas"
      @recargar_notificaciones="recargar_notificaciones"
      @on_no_asignada="cerrar_notificacion"
    />


    <DialogCambiarUsuario
        v-if="dialog_cambiar_usuario"
        v-model="dialog_cambiar_usuario"
    />

    <DialogCambiarCentro
        v-if="dialog_cambiar_centro"
        v-model="dialog_cambiar_centro"
    />

    <DialogCumplesClientes
        v-if="dialog_cumples_clientes"
        v-model="dialog_cumples_clientes"
    />

    <DialogTarjetaCredito
        v-if="dialog_tarjeta_credito"
        v-model="dialog_tarjeta_credito"
    />

    <!-- Dialog contratar distribuidor -->
      <DialogContratarDistribuidor
        ref="dialog_contratar_distribuidor"
      />

    <FormComprarBonos
        v-if="dialog_comprar_bonos"
        v-model="dialog_comprar_bonos"
        @on_compra_bono_sms="compra_bono_sms"
    />
  </v-app-bar>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import DialogCumplesClientes from "../appbarcomponents/DialogCumplesClientes";
import DialogBuscadorAppBarMovil from "@/components/core/DialogBuscadorAppBarMovil.vue";
import ortracker from "../../plugins/openreplay";
import CONSTANTS from '@/utils/constants'
import store from "@/store";

export default {
  data() {
    return {
      CONSTANTS,
      show_top_menu: false,
      cliente_autocomplete: null,
      cliente_autocomplete_entries: [],
      cliente_autocomplete_q: '',
      notificaciones: [],
      notificacion_seleccionada: null,
      dialog_detalle_notificacion: false,
      dialog_cambiar_usuario: false,
      dialog_cambiar_centro: false,
      show_notificaciones_pasadas: false,
      clientes_cumpleanios: 0,
      dialog_cumples_clientes: false,
      show_buscar_cliente: false,

      // Debounce autocomplete cliente
      autocomplete_cliente_contador: null,
      autocomplete_cliente_timeout: 500,
      dialog_comprar_bonos: false,
      dialog_tarjeta_credito: false,
    }
  },

  methods: {
    ...mapMutations(['set_drawer']),
    logout() {
      this.$socket.close()
      //TODO: Aunque cerremos la conexión, se vuelve a reconectar automáticamente
     // Mandamos al backend una peticion para anular el token

     // Limpiamos la caché del forumlario de citas
     this.$store.commit('cita/clear_form_cita')
     this.$store.commit('cita/set_force_refresh', true)

     this.$router.push({name: 'login'}).catch((err) => console.log(err))
    },

    reset_autocomplete() {
      this.cliente_autocomplete = null
      this.cliente_autocomplete_q = ''
      this.cliente_autocomplete_entries = []
      this.$refs.autocomplete.internalValue = 0
    },

    async get_clientes_autocomplete() {
      if (this.cliente_autocomplete_q.length < 3) return
      const resp = await this.$store.dispatch('cliente/get_clientes_autocomplete', this.cliente_autocomplete_q)
      this.cliente_autocomplete_entries = resp.results
    },

    async cliente_autocomplete_change() {
      if (!this.cliente_autocomplete) return;
      const id_cliente = this.cliente_autocomplete

      this.reset_autocomplete()
      const reload = this.$route.name === 'ficha_cliente'

      this.show_buscar_cliente=false
      await this.$router.push({name: 'ficha_cliente', params: {id: id_cliente}})
      if (reload) {
        this.$router.go(0)
      }
    },


    /**
     * Actualiza el idioma del usuario tanto en la api como en el frontend
     * @param idioma_id
     * @returns {Promise<void>}
     */
    async change_language(idioma_id) {
      this.show_top_menu = false
      try {
        // Actualizamos el usuario en la api
        const user = await this.$store.dispatch('auth/update', {id: this.user.id, user: {idioma: idioma_id}})

        // Guardamos el locale en el store
        const locale = user.idioma_obj.locale
        await this.$store.dispatch('locale/set_locale', locale)

        // Recargamos la vista
        await this.$router.replace({name: this.$route.name, params: {lang: locale}}).catch(() => {
        })
        this.$router.go(0)
      } catch (err) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    go_to_perfil(){
      const route_name = this.$route.name
      this.$router.push({name: 'ficha_empleado', params: {id: this.user.id}})
      // Si estamos en la ficha del empleado, forzamos que se recargue la ruta
      if(route_name === 'ficha_empleado'){
        this.$router.go(0)
      }
    },

    async abrir_notificacion(notificacion_id) {
      this.notificacion_seleccionada = notificacion_id
      this.dialog_detalle_notificacion = true
    },

    // si no se queda el dialog notificacion abierto y vacío
    cerrar_notificacion(){
      this.$snotify.warning(
        this.$t('La notificación no está asignada'),
        this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
      )
      this.notificacion_seleccionada = null
      this.dialog_detalle_notificacion = false
    },

    async get_notificaciones(ver_antiguas){
      // Si es la central, no se cargan las notificaciones
      if(this.centro.is_central){
        return
      }
      this.show_notificaciones_pasadas=ver_antiguas
      let respuesta = await this.$store.dispatch('notificaciones_koibox/get_notificaciones', {
        leida_by__isnull: ver_antiguas,
        fecha__lte: this.$moment().format('YYYY-MM-DD'),
        exclude: this.$store.state.centro.centro.id,
        idioma: store.getters["locale/get_locale"]
      })
      this.notificaciones = respuesta['results']

      if(!ver_antiguas && this.$store.state.auth.user.tipo_empleado === 'admin'
          && !this.$store.state.auth.user.is_superuser && this.notificaciones.length > 0 &&
          this.$store.state.centro.centro.is_asistente_completado) {
        await this.abrir_notificacion(this.notificaciones[0].id)
      }
    },

    open_dialog_cambiar_usuario () {
      if (this.show_cambiar_usuario) {
        if(this.user.tipo_empleado === 'recepcionista'){
          this.dialog_cambiar_centro = true
        }else{
          this.dialog_cambiar_usuario = true
        }
      }
    },

    recargar_notificaciones () {
      this.dialog_detalle_notificacion = false
      this.notificacion_seleccionada = null
      this.get_notificaciones(false)
    },

    open_admin () {
      if (process.env.VUE_APP_API_BASE_URL === 'https://api.preprod.koibox.cloud') {
        window.open('https://admin.preprod.koibox.cloud', '_blank')
      } else {
        window.open('https://admin.koibox.cloud', '_blank')
      }
    },

    async get_cumpleanios () {
      const response = await this.$store.dispatch('centro/get_cumpleanios')
      this.clientes_cumpleanios = response.count
    },

    async enable_openreplay() {
      try {
        await ortracker.start()
        ortracker.setUserID(this.user.email)
        ortracker.setMetadata('centro', `[${this.$store.state.centro.centro.id}] ${this.$store.state.centro.centro.nombre}`)
        ortracker.setMetadata('empresa', `[${this.$store.state.centro.centro.empresa.id}] ${this.$store.state.centro.centro.empresa.nombre}`)
      } catch (e) {
        return this.$snotify.error(
          this.$t('No se ha podido activar la asistencia remota'),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }

      return this.$snotify.info(
          this.$t('Se ha activado la asistencia remota'),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
      )
    },

    async on_click_sin_credito_sms(){
      // Comprobamos que el centro no sea de Sebymar
      if(this.centro.distribuidor === CONSTANTS.DISTRIBUIDORES.SEBYMAR){
        const distribuidor = this.centro.distribuidor_obj
        this.$refs.dialog_contratar_distribuidor.open_dialog(distribuidor)
        return
      }

      try{
        const tarjeta_credito = await this.$store.dispatch("tarjeta_credito/get")
        if(tarjeta_credito){
          this.dialog_comprar_bonos = true
          return
        }
      }catch (e){}
      this.$snotify.info(
          this.$t("Para comprar un bono de SMS es necesario que registres una tarjeta de crédito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
      )
      this.dialog_tarjeta_credito = true
    },

    compra_bono_sms (plan_seleccionado) {
      switch (plan_seleccionado) {
        case CONSTANTS.PLANES_KOIBOX.PACK_100_SMS:
          this.$store.state.centro.centro.credito_sms_restante += 100
          break
        case CONSTANTS.PLANES_KOIBOX.PACK_500_SMS:
          this.$store.state.centro.centro.credito_sms_restante += 500
          break
        case CONSTANTS.PLANES_KOIBOX.PACK_1000_SMS:
          this.$store.state.centro.centro.credito_sms_restante += 1000
          break
        case CONSTANTS.PLANES_KOIBOX.PACK_3000_SMS:
          this.$store.state.centro.centro.credito_sms_restante += 3000
          break
      }
      this.dialog_comprar_bonos = false
    }
  },

  async mounted() {
    await this.get_notificaciones(false)

    if (this.centro.is_aviso_notificaciones_cumpleanios) {
      await this.get_cumpleanios()
    }

    // Debouncer autocomplete cliente
    // Al dejar de escribir, inicializamos el contador
    // Buscamos el input en el DOM
    let input;
    input = document.getElementById('appbar_autocomplete_cliente')
      if(!input){
        input = document.getElementById('appbar_movil_autocomplete_cliente')
      }
      if(input){
        input.addEventListener('keyup', () => {
          clearTimeout(this.autocomplete_cliente_contador);
          this.autocomplete_cliente_contador = setTimeout(() => {
            this.get_clientes_autocomplete();
          }, this.autocomplete_cliente_timeout);
        });
        input.addEventListener('keydown', () => {
            clearTimeout(this.autocomplete_cliente_contador);
        });
      }
  },

  computed: {
    ...mapState(['drawer']),
    socketConnected: {
      get() {
        return this.$store.state.socket.isConnected
      }
    },

    search: {
      get() {
        return this.cliente_autocomplete_q
      },

      set(searchInput) {
        if (!searchInput) return;
        if (this.cliente_autocomplete_q !== searchInput) {
          this.cliente_autocomplete_q = searchInput
          // this.get_clientes_autocomplete()
        }
      }
    },

    user: function () {
      return this.$store.state.auth.user
    },

    centro: function() {
      return this.$store.state.centro.centro
    },

    show_email_cliente(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("ver_email_cliente")) {
          return true
        }
      }
      return false
    },

    show_movil_cliente(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("ver_movil_cliente")) {
          return true
        }
      }
      return false
    },

    show_cambiar_usuario(){
      return this.$store.getters['auth/autologin_token'] || this.user.is_admin_franquicia || this.user.tipo_empleado === 'recepcionista'
    },

    credito_sms_restante(){
      return this.$store.state.centro.centro.credito_sms_restante
    },

    color_plan () {
      switch (this.centro.plan_contratado) {
        case CONSTANTS.PLANES_KOIBOX.LITE:
          return '#1993AF'
        case CONSTANTS.PLANES_KOIBOX.BASIC:
          return '#006DA7'
        case CONSTANTS.PLANES_KOIBOX.GOLD:
          return '#f19820'
        case CONSTANTS.PLANES_KOIBOX.SKEYNDOR:
          return '#484242'
        case CONSTANTS.PLANES_KOIBOX.PLATINUM:
          return '#858585'
      }
    }
  },

  components: {
    DialogBuscadorAppBarMovil,
    DialogCumplesClientes,
    DialogNotificationDetalle: () => import('../appbarcomponents/DialogNotificationDetalle'),
    DialogCambiarUsuario: () => import('../change_centro/DialogCambiarUsuario'),
    DialogCambiarCentro: () => import('../change_centro/DialogCambiarCentro'),
    DialogTarjetaCredito: () => import('@/views/Configuracion/DialogTarjetaCredito'),
    DialogContratarDistribuidor: () => import('@/components/shared/DialogContratarDistribuidor'),
    FormComprarBonos: () => import('@/views/Marketing/components/FormComprarBonos')
  }
}
</script>
<style scoped>
.v-list.notificacion{
  max-height:450px;
  overflow-y:auto
}
.notificacion .v-toolbar{
  position: -webkit-sticky;
  position: sticky;
}
</style>
